module.exports = __webpack_public_path__ + "img/img_remote_system03.e036602b.jpg";